import MainLogo from "../svg/main_logo.png";
import "./under-info.css";
import { ReactComponent as VkIcon } from "../svg/vk_icon.svg";
import { ReactComponent as TelegramIcon } from "../svg/telegram_icon.svg";
import { ReactComponent as WhatsAppIcon } from "../svg/whatsapp_icon.svg";
import { ReactComponent as MaxIcon } from "../svg/max_icon.svg";

const UnderInfo = () => {
  return (
    <div className="underInfo">
      <div className="underInfo_row_1">
        <div className="underInfo_logo">
          <img src={MainLogo}></img>
        </div>

        <div className="underInfo_contact">
          <div className="underInfo_contact_chats">
            <VkIcon />
            <TelegramIcon />
            <WhatsAppIcon />
            <MaxIcon />
          </div>
          <div className="underInfo_phone">
            <span>+7(999)800-71-02</span>
            <span>с 9:00 до 23:00 без выходных</span>
          </div>
        </div>
      </div>

      <div className="underInfo_row_2">
        <div className="underInfo_row_2_coop">
          <span>© 2026 car-inspector.ru</span>
          <span>Все права защищены.</span>
        </div>
      </div>
    </div>
  );
};

export default UnderInfo;
